import CanvasGraphQLReaderNode from './types/canvas-graphql-reader';
import CanvasReaderNode from './types/canvas-reader';
import CanvasWriterNode from './types/canvas-writer';

export const canvasNodes = {
  canvasReader: CanvasReaderNode,
  canvasWriter: CanvasWriterNode,
  canvasGraphQLReader: CanvasGraphQLReaderNode,
};
